module.exports = __webpack_public_path__ + "media/images/download-page-imgs-01-c61750e5.png";